<div class="payment-submit-btn-container" *ngIf="acceptance">
  <button
    (click)="submit()"
    [disabled]="disabled"
    color="warn"
    mat-raised-button
    *ngIf="acceptance.isUserLoggedIn && acceptance.isUserActivated"
    style="width: 100%"
  >
    <span *ngIf="acceptance.isUserActivated && acceptance.isUserLoggedIn">{{
      submitTitle || "ادامه خرید"
    }}</span>
    <span *ngIf="!acceptance.isUserActivated && acceptance.isUserLoggedIn"
      >فعال کردن حساب و ادامه</span
    >
    <span *ngIf="!acceptance.isUserLoggedIn && !acceptance.isUserActivated"
      >ورود به س ایت و ادامه</span
    >
  </button>
</div>
